import {
  isToday,
  isYesterday,
  isThisWeek,
  startOfWeek,
  isThisMonth,
  startOfMonth,
  isWithinInterval,
  subWeeks,
  subMonths,
} from 'date-fns';

export const formatTime = (seconds: any, milliseconds: any) => {
  const totalMilliseconds = seconds * 1000 + milliseconds;
  const totalMinutes = Math.floor(totalMilliseconds / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return { hours, minutes };
};

export const convertMinutesToHours = (minutes: any) => {
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const calculedHours = hours % 24;

  if (days === 0) {
    return `${calculedHours} horas`;
  }

  return `${days} dias ${calculedHours} horas`;
};

export const formatDate = (dateStart: any) => {
  const date = new Date(dateStart);

  if (isToday(date)) {
    return 'today';
  } else if (isYesterday(date)) {
    return 'yesterday';
  } else if (isThisWeek(date)) {
    return 'week';
  } else if (isLastWeek(date)) {
    return 'lastWeek';
  } else if (isThisMonth(date)) {
    return 'thisMonth';
  } else if (isLastMonth(date)) {
    return 'lastMonth';
  }

  return 'Intervalo de datas inválido';
};

function isLastWeek(date: any) {
  const lastWeek = subWeeks(startOfWeek(new Date()), 1);
  const endLastWeek = startOfWeek(new Date());
  return isWithinInterval(date, { start: lastWeek, end: endLastWeek });
}

function isLastMonth(date: any) {
  const lastMonth = subMonths(startOfMonth(new Date()), 1);
  const endLastMonth = startOfMonth(new Date());
  return isWithinInterval(date, { start: lastMonth, end: endLastMonth });
}

export const formatDateTime = (dateString: string) => {
  return new Date(dateString).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
